
<!--  -->
<template>
  <div class="container" v-if="!isClose">
    <!-- <transition name="el-fade-in-linear"> -->
    <div class="container-context" v-show="!isMinShow">
      <div class="left">
        <h4 class="context-title">下载列表</h4>
        <div
          class="context-down-list"
          v-for="(item, index) in downs"
          :key="index"
        >
          <down-item ref="downItemRef" :data="item" />
        </div>
      </div>
      <div class="right">
        <i class="icon el-icon-close close-btn" @click="isClose = true"></i>
        <i class="icon el-icon-bottom-right" @click="isMinShow = true"></i>
      </div>
    </div>
    <!-- </transition> -->
    <!-- <transition name="el-fade-in-linear"> -->
    <div class="container-float" v-show="isMinShow" @click="isMinShow = false">
      <i class="el-icon-download download-btn"></i>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
import DownItem from "./components/DownItem";
export default {
  name: "XNotification",
  components: { DownItem },
  data() {
    return {
      isClose: true, // 是否关闭
      isMinShow: false, // 是否最小化
      downs: [], // 下载列表
    };
  },
  watch: {
    "$store.state.XNotification.downs": {
      handler(newValue) {
        // this.downs = newValue;
        // this.downs = newValue;
        this.downs = [...newValue];
        // console.log(newValue, this.downs);
        this.$refs["downItemRef"]?.[0].changeItemData();
        // console.log(newValue);
        // newValue.forEach((item, index) => this.$set(this.downs, index, item));
        // console.log(this.downs);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  padding: 0;
}
.container-context,
.container-float {
  background-color: #fff;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
}
.container-context {
  display: flex;
  padding: 10px;
  min-width: 50px;
  min-height: 40px;
  border-radius: 10px;
}

.container-context .left {
  padding-right: 15px;
  flex: 1;
}

.container-context .left .context-title {
  line-height: 0;
}
.right .close-btn:hover,
.container-float:hover {
  cursor: pointer;
}

.container-context .right {
  display: flex;
  flex-direction: column;
}

.container-context .right .icon {
  margin-bottom: 5px;
}

.container-context .right .icon:last-child {
  margin: 0;
}

.container-float {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.container .download-btn {
  font-size: 25px;
}
</style>

